import { ReopenLodgingRequestState, ReopenLodgingRequestActionTypes, REOPEN_LODGING_REQUEST_REQUEST, REOPEN_LODGING_REQUEST_SUCCESS, REOPEN_LODGING_REQUEST_FAILURE } from "store/reducers/lodgingRequest/reopen/types";

const defaultState: ReopenLodgingRequestState = {
  isLoading: false,
  errorMessage: ""
};

export default function ReopenLodgingRequest(state = defaultState, action: ReopenLodgingRequestActionTypes): ReopenLodgingRequestState {
  switch (action.type) {
    case REOPEN_LODGING_REQUEST_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case REOPEN_LODGING_REQUEST_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case REOPEN_LODGING_REQUEST_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};